import React from 'react';

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 bg-black"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div className="flex items-center gap-2">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-un-lime overflow-hidden">
                        <img
                            src="/uncloned-logo.webp"
                            alt="UnCloned®"
                            data-testid="footer-brand-icon"
                            className="h-6 w-6 object-contain"
                            style={{ filter: 'brightness(0)' }}
                        />
                    </span>
                    <div>
                        <div
                            data-testid="footer-brand-name"
                            className="font-display font-black text-white text-sm uppercase tracking-[0.14em]"
                        >
                            UnCloned<span className="text-un-berry">®</span> Brand Awards
                        </div>
                        <div className="text-[11px] uppercase tracking-[0.22em] text-white/50">
                            Recognizing the un-copyable
                        </div>
                    </div>
                </div>
                <div className="text-xs uppercase tracking-[0.14em] text-white/50 font-body">
                    © {new Date().getFullYear()} UnCloned<span className="text-un-berry">®</span>. All rights reserved.
                </div>
            </div>
        </footer>
    );
}
